module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-1.29509bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-1.jpg
// module id = L65+
// module chunks = 1